import {SalaryList} from "./SalaryList";
import {SalaryEdit} from "./SalaryEdit";
import {SalaryCreate} from "./SalaryCreate";

export default {
    list: SalaryList,
    create: SalaryCreate,
    edit: SalaryEdit
};
